import { ErrorHandler, inject, Injectable, NgZone } from '@angular/core';
import { ErrorDialogService } from '../services/error-dialog.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly ngZone = inject(NgZone);
  private readonly errorDialogService = inject(ErrorDialogService);

  handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : String(error);
    console.error('[SNCRP GlobalErrorHandler]', error);
    this.ngZone.run(() => {
      this.errorDialogService.showError({
        title: 'Application Error',
        message,
      });
    });
  }
}
